module.exports = __webpack_public_path__ + "assets/media/data-integrations-cover.d4532551.png";